<template>
  <div>
    <Tabs :value="tabStr" @on-click="tabChange">
      <TabPane label="待审核" name="pending">
        <Row :gutter="8" style="margin-bottom:10px">
          <Col span="4">
            <Input v-model="name" type="text" placeholder="姓名" clearable @on-clear="searchChange" />
          </Col>
          <Col span="4">
            <Button type="primary" icon="ios-search" @click="search">查询</Button>
          </Col>
        </Row>
        <Table border ref="table" size="small" :columns="pendingColumns" :data="tableData" :height="tableHeight" :empty-text="emptyText"></Table>
        <Row style="margin-top:10px;text-align:center">
          <Page :total="total" :page-size="pageSize" :current="pageNumber" show-elevator show-sizer show-total
            @on-change="pageChange" @on-page-size-change="pageSizeChange" />
        </Row>
      </TabPane>
      <TabPane label="已审核" name="approved">
        <Row :gutter="8" style="margin-bottom:10px">
          <Col span="4">
            <Input v-model="name" type="text" placeholder="姓名" clearable @on-clear="searchChange" />
          </Col>
          <Col span="4">
            <Button type="primary" icon="ios-search" @click="search">查询</Button>
          </Col>
        </Row>
        <Table border ref="table" size="small" :columns="approvedColumns" :data="tableData" :height="tableHeight" :empty-text="emptyText"></Table>
        <Row style="margin-top:10px;text-align:center">
          <Page :total="total" :page-size="pageSize" :current="pageNumber" show-elevator show-sizer show-total
            @on-change="pageChange" @on-page-size-change="pageSizeChange" />
        </Row>
      </TabPane>
    </Tabs>

    <Modal v-model="detailModal" title="积分明细查看" width="760">
      <Form :label-width="120">
        <Row>
          <Col span="22">
            <FormItem label="日期"><Input disabled :value="detailForm.recordDate" /></FormItem>
            <FormItem label="姓名"><Input disabled :value="detailForm.name" /></FormItem>
            <FormItem label="身份证号码"><Input disabled :value="detailForm.idCard" /></FormItem>
            <FormItem label="参与大类"><Input disabled :value="detailForm.category" /></FormItem>
            <FormItem label="具体事项"><Input disabled type="textarea" :value="detailForm.detail" /></FormItem>
            <FormItem label="积分"><Input disabled :value="detailForm.branch" /></FormItem>
            <FormItem label="审核状态"><Input disabled :value="detailForm.status == 10 ? '已审核' : '待审核'" /></FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="default" @click="detailModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "integralPeopleItemAudit",
  data() {
    return {
      name: "",
      tabStr: "pending",
      detailModal: false,
      detailForm: {},
      pendingColumns: [
        { title: "序号", width: 80, align: "center", render: (h, p) => h("span", p.index + 1) },
        { title: "日期", key: "recordDate", minWidth: 120, align: "center", tooltip: true },
        { title: "姓名", key: "name", minWidth: 100, align: "center", tooltip: true },
        { title: "身份证号码", key: "idCard", minWidth: 180, align: "center", tooltip: true },
        { title: "参与大类", key: "category", minWidth: 180, align: "center", tooltip: true },
        { title: "具体事项", key: "detail", minWidth: 200, align: "center", tooltip: true },
        { title: "积分", key: "branch", minWidth: 80, align: "center" },
        { title: "操作", minWidth: 120, align: "center",
          render: (h, p) => h("Button", { props: { type: "primary", size: "small" }, on: { click: () => this.approveConfirm(p.row.id) } }, "审核") },
      ],
      approvedColumns: [
        { title: "序号", width: 80, align: "center", render: (h, p) => h("span", p.index + 1) },
        { title: "日期", key: "recordDate", minWidth: 120, align: "center", tooltip: true },
        { title: "姓名", key: "name", minWidth: 100, align: "center", tooltip: true },
        { title: "身份证号码", key: "idCard", minWidth: 180, align: "center", tooltip: true },
        { title: "参与大类", key: "category", minWidth: 180, align: "center", tooltip: true },
        { title: "具体事项", key: "detail", minWidth: 200, align: "center", tooltip: true },
        { title: "积分", key: "branch", minWidth: 80, align: "center" },
        { title: "操作", minWidth: 120, align: "center",
          render: (h, p) => h("Button", { props: { type: "info", size: "small" }, on: { click: () => this.viewDetail(p.row) } }, "查看") },
      ],
      tableData: [], tableHeight: 500, total: 0, pageNumber: 1, pageSize: 10,
      emptyText: "暂无数据",
    };
  },
  created() { this.getData(); },
  mounted() {
    this.$nextTick(() => { this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 280; });
  },
  methods: {
    getData() {
      let status = this.tabStr == "pending" ? 0 : 10;
      let msg = this.$Message.loading({ content: "正在获取数据", duration: 0 });
      this.$http.get("/api/tIntegralPeopleItem/page", { params: { name: this.name, status, currentPage: this.pageNumber, pageSize: this.pageSize } }).then(r => { msg(); if (r.data.code == 200) { this.tableData = r.data.data.list || []; this.total = r.data.data.total; } }).catch(() => msg());
    },
    tabChange(name) { this.tabStr = name; this.pageNumber = 1; this.getData(); },
    search() { this.pageNumber = 1; this.getData(); },
    pageChange(p) { this.pageNumber = p; this.getData(); },
    pageSizeChange(s) { this.pageSize = s; this.pageNumber = 1; this.getData(); },
    viewDetail(row) {
      this.detailForm = row;
      this.detailModal = true;
    },
    approveConfirm(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认审核通过该条记录？",
        onOk: () => {
          this.$http.get("/api/tIntegralPeopleItem/approve", { params: { id } }).then(r => {
            if (r.data.code == 200) {
              this.$Message.success("审核成功");
              if (this.tableData.length <= 1 && this.pageNumber > 1) this.pageNumber--;
              this.getData();
            } else {
              this.$Message.error(r.data.msg);
            }
          });
        },
      });
    },
    searchChange() { this.getData(); },
  },
};
</script>
<style scoped>.ivu-row { margin-bottom: 10px; }</style>
